import { inject, Injectable } from '@angular/core';
import { CheckoutSessionsRepository } from '@repositories';
import { DocumentReference, onSnapshot } from 'firebase/firestore';
import { PlanPaymentPeriod, PlanType } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class PlanPaymentService {
    private readonly checkoutSessionsRepository = inject(CheckoutSessionsRepository);

    public async process(planType: PlanType, period: PlanPaymentPeriod): Promise<unknown> {
        const docRef = await this.checkoutSessionsRepository.create(planType, period);

        if (!docRef) {
            return;
        }

        return this.initOnSnapshotListener(docRef);
    }

    private initOnSnapshotListener(docRef: DocumentReference): Promise<unknown> {
        return new Promise((resolve) => {
            onSnapshot(docRef, (snap) => {
                const data = snap.data() as any;

                if (data?.url) {
                    resolve(data);

                    window.location.href = data.url;
                }
            });
        });
    }
}
